import { UseMainUIFeatureSettings } from '../types';

import { useCampaignsDashboardPageSettings } from './campaign';
import { useDiscoverGroupsPageSettings } from './group';
import { useInboxPageSettings } from './inbox';
import {
  useInsightsCampaignPageSettings,
  useInsightsLeadersMyInsightsPageSettings,
  useInsightsLeadersOrgPageSettings,
  useInsightsNavigationSettings,
  useInsightsQnAMyInsightsPageSettings,
  useInsightsQnAOrgPageSettings,
} from './insights';
import { useNavigationSettings } from './navigation';
import { useLongFormContentSettings } from './publisher';
import { useStrictFeatureSettings } from './useStrictFeatureSettings';

export const useMainFeatureSettings: UseMainUIFeatureSettings = (...args) => {
  const campaignsDashboardPage = useCampaignsDashboardPageSettings(...args);
  const discoverGroupsPage = useDiscoverGroupsPageSettings(...args);
  const inboxPage = useInboxPageSettings(...args);
  const insightsCampaignPage = useInsightsCampaignPageSettings(...args);
  const insightsLeadersMyInsightsPage = useInsightsLeadersMyInsightsPageSettings(...args);
  const insightsLeadersOrgPage = useInsightsLeadersOrgPageSettings(...args);
  const insightsNavigation = useInsightsNavigationSettings(...args);
  const insightsQnAMyInsightsPage = useInsightsQnAMyInsightsPageSettings(...args);
  const insightsQnAOrgPage = useInsightsQnAOrgPageSettings(...args);
  const longFormContent = useLongFormContentSettings(...args);
  const navigation = useNavigationSettings(...args);

  return useStrictFeatureSettings({
    campaignsDashboardPage,
    discoverGroupsPage,
    inboxPage,
    insightsCampaignPage,
    insightsLeadersMyInsightsPage,
    insightsLeadersOrgPage,
    insightsNavigation,
    insightsQnAMyInsightsPage,
    insightsQnAOrgPage,
    longFormContent,
    navigation,
  });
};
